export enum InheritedValueType {
  None = 'None',
  Include = 'Include',
  Only = 'Only'
}
